import { Col, Row } from "react-bootstrap";
import { RECEIVING_CHECKLIST_QUESTIONS } from "MODULES/Receiving/constants";
import React from "react";
import {
  form,
  Form as AppForm,
  FormRow,
  TextArea
} from "MODULES/shared/components/Forms";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { update, discrepanciesPageActions } from "MODULES/Receiving/actions";
import validate from "./validate";

const renderChecklistQuestion = (attr, getField, change) => (
  <Row className="row-col-gutters-half" key={attr}>
    <Col md={1} className="text-center">
      <label className="control-label" htmlFor={attr}>
        Agree
      </label>
      <br />
      <input
        type="radio"
        name={attr}
        className="radio-inline"
        checked={getField(attr)}
        onChange={() => change(attr, true)}
      />
    </Col>
    <Col md={1} className="text-center">
      <label className="control-label" htmlFor={attr}>
        Disagree
      </label>
      <br />
      <input
        type="radio"
        name={attr}
        className="radio-inline"
        checked={!getField(attr)}
        onChange={() => change(attr, false)}
      />
    </Col>
    <Col md={10}>{RECEIVING_CHECKLIST_QUESTIONS[attr]}</Col>
    <br />
    <br />
    <br />
  </Row>
);

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        {Object.keys(RECEIVING_CHECKLIST_QUESTIONS).map(k =>
          renderChecklistQuestion(k, props.getField, props.change)
        )}
        <FormRow>
          <Col md={12}>
            <Field
              name="question_checklist_change_reason"
              component={TextArea}
              rows={5}
              label="Change Reason"
              required
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

const FORM_NAME = "editQuestionList";

export default connect(
  state => ({
    getField: field => formValueSelector(FORM_NAME)(state, field)
  }),
  dispatch => ({
    onSubmit: data =>
      Promise.resolve(dispatch(update(data))).then(() =>
        dispatch(discrepanciesPageActions.expire())
      )
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/EditQuestionsChecklist/Form.jsx